import {
  CircularProgress,
  Collapse,
  Grid,
  Typography
} from "@material-ui/core";
import React from "react";
import {makeStyles} from "@material-ui/styles";
import {ExpandLess, ExpandMore} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  contentSection: {
    padding: '16px 22px',
    background: '#fff',
    marginBottom: '15px',
    borderRadius: '3px',
  },
  contentSectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    cursor: 'pointer'
  },
  contentSectionHeaderTitle: {
    fontSize: '17px',
    fontWeight: '600',
    color: '#000',
  },
  contentSectionContent: {

  },
  formGroup: {
    padding: theme.spacing(2, 0)
  },
  form: {
    height: '100%',
  },
  field: {
    '& label.Mui-focused': {
      color: '#000',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#000',
    },
    '& .MuiOutlinedInput-root': {
      '&:hover fieldset': {
        borderColor: '#000',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#000',
      },
    },
  },
  tabActive: {
    color: '#1E69E5',
  },
  associationLink: {
    position: 'absolute',
    top: '-10px',
    right: '10px',
    cursor: 'pointer',
    decoration: 'none',
    '&:hover': {
      decoration: 'none',
    }
  },
  inheritFontWeight: {
    fontWeight: 'inherit',
  },
  tableMarginTop: {
    marginTop: 24,
  },
}));

// const contactGeneralInfoCompany = [
//   { id: 'currently_employed_company_crd_id', name: 'currently_employed_company_crd_id'},
//   { id: 'currently_employed_company_name', name: 'currently_employed_company_name'},
// ]

const General = ({ relationships, statusRelationships, handleTabChange, tab, tabNumber, contact, entityType, ...props}) => {
  let contactGeneralInfo = [];
  const classes = useStyles();

  if (entityType === 'BD') {
    contactGeneralInfo = [
      { id: 'contact_crd_id', name: 'Contact_CRD' },
      { id: 'contact_link_broker_dealer', name: 'contact_link_to_SEC_file' },
      { id: 'contact_first_name', name: 'contact_first_name' },
      { id: 'contact_last_name', name: 'contact_last_name' },
      { id: 'contact_middle_name', name: 'contact_middle_name' },
      { id: 'contact_surffix_name', name: 'contact_surffix_name' },
      { id: 'contact_first_name_other_bd', name: 'contact_first_name_other' },
      { id: 'contact_last_name_other_bd', name: 'contact_last_name_other' },
      { id: 'contact_middle_name_other_bd', name: 'contact_middle_name_other' },
      { id: 'contact_surffix_name_other_bd', name: 'contact_surffix_name_other' },
      { id: 'other_business_activities', name: 'other_business_activities' },
    ]
  } else {
    contactGeneralInfo = [
      { id: 'contact_crd_id', name: 'Contact_CRD' },
      { id: 'contact_link', name: 'contact_link_to_SEC_file' },
      { id: 'contact_first_name', name: 'contact_first_name' },
      { id: 'contact_last_name', name: 'contact_last_name' },
      { id: 'contact_middle_name', name: 'contact_middle_name' },
      { id: 'contact_surffix_name', name: 'contact_surffix_name' },
      { id: 'contact_first_name_other', name: 'contact_first_name_other' },
      { id: 'contact_last_name_other', name: 'contact_last_name_other' },
      { id: 'contact_middle_name_other', name: 'contact_middle_name_other' },
      { id: 'contact_surffix_name_other', name: 'contact_surffix_name_other' },
      { id: 'other_business_activities', name: 'other_business_activities' },
    ]
  }

  return (
    <div className={classes.contentSection}>
      <div className={classes.contentSectionHeader} onClick={(event) => handleTabChange(event, tabNumber)}>
        <Typography variant='h5' className={`${classes.contentSectionHeaderTitle} ${tab === tabNumber ? classes.tabActive : ''}`}>General</Typography>
        {statusRelationships === 'start' ? <CircularProgress /> : ''}
        {tab === tabNumber ? <ExpandLess /> : <ExpandMore />}
      </div>
      <Collapse in={tab === tabNumber}>
        <div className={classes.contentSectionContent}>
          <div className={classes.formGroup}>
            <Grid container spacing={3} >
              { contactGeneralInfo.map(((key, index) =>
                  <React.Fragment key={`${key.id}-${index}`}>
                    <Grid
                      item
                      md={6}
                      xs={12}
                    >
                      {key.name}
                    </Grid>
                    <Grid
                      item
                      md={6}
                      xs={12}
                    >
                      {contact[key.id]}
                    </Grid>
                  </React.Fragment>
              )) }

              {/* { relationships.currentCompanies.map(((key, index) =>
                  contactGeneralInfoCompany.map(((attribute) =>
                      <React.Fragment key={`${key.attributes.id}-${attribute.id}`}>
                        <Grid
                          item
                          md={6}
                          xs={12}
                        >
                          {attribute.name}
                        </Grid>
                        <Grid
                          item
                          md={6}
                          xs={12}
                        >
                          {key.attributes[attribute.id]}
                        </Grid>
                      </React.Fragment>
                  ))
              )) } */}
            </Grid>
          </div>
        </div>
      </Collapse>
    </div>
  )
}

export default General;